import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Image } from "react-bootstrap";
import { Fade } from "react-reveal";
import { Form, FormGroup, Label, Input, FormText } from "reactstrap";
import Marquee from "./marquee";
import { useDispatch, useSelector } from "react-redux";
import { getSettings } from "store/actions";
import Skeleton from "react-loading-skeleton";
import bannerImg from "../../assets/images/bannerimg.png";
import BuyComponent from "../Buy";
import SellComponent from "../Sell-Crypto";
import { useTranslation } from "react-i18next";

import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useKycStatus } from "helpers/custom-hooks";

const Home = ({ settingInfo, loading }) => {
  const [state, setState] = useState({
    tab: "Buy",
  });
  const isVerified = useKycStatus();

  const [exchangeData, setExchangeData] = useState({});

  const { t } = useTranslation();
  const navigate = useNavigate();

  /**
   * Used for render the buy-sell widget on home page
   */
  return (
    <>
      <section className="home_banner_main">
        {/* <div className="wihte_circle"></div> */}
        <div className="top_circle"></div>

        <Container dir="ltr">
          <Row>
            <Col lg={6} md={12} sm={12} className="order-2 order-lg-1">
              {/* <div className="home_banner_form position-relative">
                <div className="bg_border_line"></div>
                <div className="home_banner_form2">
                  <Form className="banner_form">
                    <h4>DeFi Swap</h4>

                    <div className="banner_price_box">
                      <div className="wallet_head d-flex justify-content-between align-items-center mb-2">
                        <h5>Bitcoin</h5>
                        <p>12/24</p>
                      </div>
                      <div className="wallet_price  d-flex justify-content-between align-items-center">
                        <h3>$ 12.568,60</h3>
                        <FormGroup className="topwallect_selector position-relative">
                          <Input type="select" name="select" id="exampleSelect">
                            <option>1</option>
                            <option>2</option>
                            <option>3</option>
                            <option>4</option>
                            <option>5</option>
                          </Input>

                          <span className="topdown_icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="33"
                              height="33"
                              viewBox="0 0 33 33"
                              fill="none"
                            >
                              <path
                                d="M16.884 20.5572C16.7086 20.5582 16.5346 20.5246 16.3722 20.4582C16.2097 20.3919 16.062 20.2941 15.9374 20.1705L10.604 14.8372C10.353 14.5861 10.2119 14.2456 10.2119 13.8905C10.2119 13.5355 10.353 13.195 10.604 12.9439C10.8551 12.6928 11.1956 12.5518 11.5507 12.5518C11.9058 12.5518 12.2463 12.6928 12.4974 12.9439L16.884 17.3439L21.2707 12.9572C21.5258 12.7388 21.8539 12.6246 22.1894 12.6376C22.525 12.6506 22.8433 12.7897 23.0808 13.0271C23.3182 13.2646 23.4574 13.5829 23.4703 13.9185C23.4833 14.254 23.3691 14.5821 23.1507 14.8372L17.8174 20.1705C17.569 20.4169 17.2338 20.5557 16.884 20.5572Z"
                                fill="#8E8E8E"
                              />
                            </svg>
                          </span>
                        </FormGroup>
                      </div>
                    </div>

                    <div className="sellbuy-col mt-3">
                      <Row>
                        <Col lg={6} sm={6} xs={6}>
                          <FormGroup>
                            <Label for="selling">Sell</Label>
                            <Input
                              type="number"
                              name="sell"
                              id="selling"
                              placeholder="48.00"
                            />
                          </FormGroup>
                        </Col>

                        <Col lg={6} sm={6} xs={6}>
                          <FormGroup className="wallect_selector position-relative">
                            <Label for="selling" className="invisible">
                              selling
                            </Label>

                            <Input type="select" name="select" id="exampleSelect">
                              <option>USD</option>
                              <option>2</option>
                              <option>3</option>
                              <option>4</option>
                              <option>5</option>
                            </Input>
                            <span className="down_icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="33"
                                height="33"
                                viewBox="0 0 33 33"
                                fill="none"
                              >
                                <path
                                  d="M16.884 20.5572C16.7086 20.5582 16.5346 20.5246 16.3722 20.4582C16.2097 20.3919 16.062 20.2941 15.9374 20.1705L10.604 14.8372C10.353 14.5861 10.2119 14.2456 10.2119 13.8905C10.2119 13.5355 10.353 13.195 10.604 12.9439C10.8551 12.6928 11.1956 12.5518 11.5507 12.5518C11.9058 12.5518 12.2463 12.6928 12.4974 12.9439L16.884 17.3439L21.2707 12.9572C21.5258 12.7388 21.8539 12.6246 22.1894 12.6376C22.525 12.6506 22.8433 12.7897 23.0808 13.0271C23.3182 13.2646 23.4574 13.5829 23.4703 13.9185C23.4833 14.254 23.3691 14.5821 23.1507 14.8372L17.8174 20.1705C17.569 20.4169 17.2338 20.5557 16.884 20.5572Z"
                                  fill="#8E8E8E"
                                />
                              </svg>
                            </span>
                          </FormGroup>
                        </Col>

                        <Col lg={6} sm={6} xs={6}>
                          <FormGroup>
                            <Label for="buying">Buy</Label>
                            <Input
                              type="number"
                              name="buy"
                              id="buying"
                              placeholder="48.00"
                            />
                          </FormGroup>
                        </Col>

                        <Col lg={6} sm={6} xs={6}>
                          <FormGroup className="wallect_selector position-relative">
                            <Label for="selling" className="invisible">
                              selling
                            </Label>

                            <Input type="select" name="select" id="exampleSelect">
                              <option>USD</option>
                              <option>2</option>
                              <option>3</option>
                              <option>4</option>
                              <option>5</option>
                            </Input>
                            <span className="down_icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="33"
                                height="33"
                                viewBox="0 0 33 33"
                                fill="none"
                              >
                                <path
                                  d="M16.884 20.5572C16.7086 20.5582 16.5346 20.5246 16.3722 20.4582C16.2097 20.3919 16.062 20.2941 15.9374 20.1705L10.604 14.8372C10.353 14.5861 10.2119 14.2456 10.2119 13.8905C10.2119 13.5355 10.353 13.195 10.604 12.9439C10.8551 12.6928 11.1956 12.5518 11.5507 12.5518C11.9058 12.5518 12.2463 12.6928 12.4974 12.9439L16.884 17.3439L21.2707 12.9572C21.5258 12.7388 21.8539 12.6246 22.1894 12.6376C22.525 12.6506 22.8433 12.7897 23.0808 13.0271C23.3182 13.2646 23.4574 13.5829 23.4703 13.9185C23.4833 14.254 23.3691 14.5821 23.1507 14.8372L17.8174 20.1705C17.569 20.4169 17.2338 20.5557 16.884 20.5572Z"
                                  fill="#8E8E8E"
                                />
                              </svg>
                            </span>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Button className="btn_common w-100 rounded py-2">
                        Confirm
                      </Button>
                    </div>
                  </Form>
                  
                </div>
              </div> */}
              <div className="banner_hero_img">
                {/* <img alt="heroImage" src={bannerImg} className="img-fluid"/> */}

                <div className="tab-frame ">
                  <div className="clearfix">
                    <input
                      type="radio"
                      name="tab"
                      id="Buy"
                      checked={state.tab == "Buy"}
                      onClick={() => setState({ tab: "Buy" })}
                    />
                    <label for="Buy"> {t("buy")}</label>

                    <input
                      type="radio"
                      name="tab"
                      id="Sell"
                      checked={state.tab == "Sell"}
                      onClick={() => setState({ tab: "Sell" })}
                    />
                    <label for="Sell"> {t("sell")}</label>
                  </div>

                  {state.tab == "Buy" && (
                    <Fade>
                      <div className="mt-3">
                        <BuyComponent tab={state.tab} />
                      </div>
                    </Fade>
                  )}

                  {state.tab == "Sell" && (
                    <Fade>
                      <div className="mt-3">
                        <SellComponent tab={state.tab} />
                      </div>
                    </Fade>
                  )}
                </div>
              </div>
            </Col>

            <Col lg={6} md={12} sm={12} className="order-1 order-lg-2">
              <div className="home_banner_content">
                {loading ? (
                  <Skeleton width={"80%"} height={26} />
                ) : (
                  <div className="trusted_box position-relative">
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <g clip-path="url(#clip0_35_2297)">
                          <path
                            d="M10.0001 15.2165L4.12259 18.5065L5.43509 11.8998L0.489258 7.3265L7.17843 6.53317L10.0001 0.416504L12.8218 6.53317L19.5109 7.3265L14.5651 11.8998L15.8776 18.5065L10.0001 15.2165Z"
                            fill="#FF7A00"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_35_2297">
                            <rect width="20" height="20" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>

                    <p>{settingInfo?.heading1}</p>
                  </div>
                )}

                <div className="headin_main my-4">
                  {loading ? (
                    <Skeleton width={"100%"} height={26} />
                  ) : (
                    <div className="text_Wrap d-flex align-items-center">
                      <h1>{settingInfo?.heading2}</h1>
                      <section class="text_animation">
                        {settingInfo?.effects?.length > 0 &&
                          settingInfo?.effects?.map((obj) => (
                            <div class="first">
                              <div>
                                <h1>{obj}</h1>
                              </div>
                            </div>
                          ))}
                      </section>
                    </div>
                  )}

                  {loading ? (
                    <Skeleton width={"100%"} height={26} />
                  ) : (
                    <h1>{settingInfo?.heading3}</h1>
                  )}
                </div>
                {loading ? (
                  <Skeleton width={"100%"} height={26} />
                ) : (
                  <p className="position-relative home_para">
                    {settingInfo?.description}
                  </p>
                )}

                {loading ? (
                  <Skeleton width={"100%"} height={26} />
                ) : (
                  <ul className="about_list p-0 mt-3">
                    {settingInfo?.counts?.length > 0 &&
                      settingInfo?.counts?.map((obj) => (
                        <li>
                          <p>
                            <strong>{obj?.noOfCounts}+</strong> {obj?.name}
                          </p>
                        </li>
                      ))}
                  </ul>
                )}
              </div>
            </Col>
          </Row>
        </Container>
        <div className="bottom_circle"></div>
      </section>
      <Marquee />
    </>
  );
};

export default Home;
